import BoxBootcamps from './BoxBootcamp'
export default BoxBootcamps
